"use strict";
(self["webpackChunkFirmSupport"] = self["webpackChunkFirmSupport"] || []).push([[6064],{

/***/ 46064:
/***/ ((module) => {

module.exports = JSON.parse('{"saved":"Sparad","noteTodoSaved":"Notering/Att Göra är sparad","errorWhileSavingTodoItem":"Fel vid sparande av Notering/Att Göra"}');

/***/ })

}]);